<template>
  <v-chip class="my-1 ml-1 priority-chip" v-show="!!priority" :data-priority="priority" small :color="chipColor">{{ priority }}</v-chip>
</template>

<script>
export default {
  mounted: function() {
  },
  watch: {
  },
  props: {
    priority:{
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {

    chipColor: function() {
      if (this.priority === "PS") {
        return "yellow"
      } else {
        return ""
      }
    }

  },
  data() {
    return {
    }
  },
  methods: {

  }
}
</script>
